import { useTranslation } from "react-i18next";
import { Button } from "@/core/shared/v2/ui/button";
import { useResendVerificationCode } from "../../api/resend-verification-code.mutation";
import { useOrderingStore } from "../../store/use-ordering-store";
import { safeTrackEvent, verificationResendCodeEvent } from "../../tracking/events";
import { Error } from "../error";

type ResendCodeProps = {
  method: "account" | "guest";
};

export const ResendCode = ({ method }: ResendCodeProps) => {
  const { t } = useTranslation();
  const { setVerificationTokenUuid, verificationTokenUuid } = useOrderingStore();
  const { mutate: resendCode, isSuccess, isError, isLoading } = useResendVerificationCode({});

  const handleOnClick = () => {
    if (!verificationTokenUuid) {
      console.error("No verification token uuid");
      return;
    }

    safeTrackEvent(
      () => verificationResendCodeEvent({ method }),
      "verification_resend_code",
      "resend-code handleOnClick",
    );

    resendCode(
      { verificationTokenUuid },
      {
        onSuccess: (data) => {
          setVerificationTokenUuid(data.verificationTokenUuid);
        },
      },
    );
  };
  return (
    <>
      <div className="mt-8 flex items-center gap-3">
        {isSuccess ? (
          <p className="text-base text-grey-700">{t("GROUP_ACTIONS_ORDERING.CODE_VALIDATION_FORM.RESEND_SUCCESS")}</p>
        ) : (
          <>
            <p className="text-base text-grey-700">
              {t("GROUP_ACTIONS_ORDERING.CODE_VALIDATION_FORM.CODE_NOT_RECEIVED")}
            </p>
            <Button variant="link" onClick={handleOnClick} disabled={isLoading} type="button">
              {t("GROUP_ACTIONS_ORDERING.CODE_VALIDATION_FORM.RESEND_CODE")}
            </Button>
          </>
        )}
      </div>
      {isError && <Error error={t("COMMONS.ERRORS.GENERAL_API_ERROR")} className="mt-2 text-center" />}
    </>
  );
};
